import * as tslib_1 from "tslib";
// Core packages
import { formatDate } from '@angular/common';
import { ElementRef, OnDestroy, OnInit, SimpleChange } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import * as FileSaver from "file-saver";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { finalize, startWith, take, takeUntil, tap } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { CondoStructuresService } from "../../condo-structures.service";
// import { PropertyDetailMappingNoteDialogComponent } from "../../components/mapping-note-dialog/mapping-note-dialog.component";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { PrintQrcodeDialogComponent } from 'src/app/modules/companies/components/print-qrcode-dialog/print-qrcode-dialog.component';
import { ExportContractsDialogComponent } from 'src/app/modules/properties/components/export-contracts-dialog/export-contracts-dialog.component';
import { ExportRasDocsDialogComponent } from 'src/app/modules/properties/components/export-ras-docs-dialog/export-ras-docs-dialog.component';
import { openDocumentArchiveExportContractsDialog } from "src/app/modules/properties/components/document-archive-export-contracts-dialog/document-archive-export-contracts-dialog.component";
import { openDocumentArchiveExportRasDialog } from "src/app/modules/properties/components/document-archive-export-ras-dialog/document-archive-export-ras-dialog.component";
import { DocumentArchiveExportDownloadService } from "src/app/modules/properties/document-archive-export-download.service";
import { documentArchiveExportTargetOf, hasDocumentArchiveExportMenu, legacyPageExportMenu, } from "src/app/modules/properties/document-archive-export.utils";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { AddCommunicationDialogComponent } from "src/app/shared/components/dialogs/add-communication-dialog/add-communication-dialog.component";
import { PropertyDetailDocumentNoteDialogComponent } from "../../components/document-note-dialog/document-note-dialog.component";
import { PropertyDetailMappingDeleteDialogComponent } from "../../components/mapping-delete-dialog/mapping-delete-dialog.component";
import { PropertyDetailMappingRemakeDialogComponent } from "../../components/mapping-remake-dialog/mapping-remake-dialog.component";
import { MappingArchiveDocsDialogComponent, } from "../../components/mapping-archive-docs-dialog/mapping-archive-docs-dialog.component";
import { remakePlantSelection } from "../../mapping-archive-docs.utils";
import { isArchiveV3Live } from "src/app/shared/utils/archive-switch.utils";
import { DocumentArchivesService } from "../../document-archives.service";
import { PropertyEditNoteDialogComponent } from "../document-edit-note-dialog/document-edit-note-dialog.component";
import { PropertyDetailMappingViewDialogComponent } from "../mapping-view-dialog/mapping-view-dialog.component";
/**
 * Script start
 */
var PropertyDetailMappingTabComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyDetailMappingTabComponent(configService, propertiesService, router, activatedRoute, toastrService, helperService, translateService, authService, cookieService, dialog, condoStructuresService, documentArchivesService, settingsService, companiesService, documentArchiveExportDownloadService) {
        this.configService = configService;
        this.propertiesService = propertiesService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.dialog = dialog;
        this.condoStructuresService = condoStructuresService;
        this.documentArchivesService = documentArchivesService;
        this.settingsService = settingsService;
        this.companiesService = companiesService;
        this.documentArchiveExportDownloadService = documentArchiveExportDownloadService;
        this.subscriptions = [];
        this.onDestroy$ = new Subject();
        this.loggedUserToleType = "";
        this.loggedUserShared = false;
        this.loggedUserTemporary = false;
        this.loggedUserMaster = false;
        this.loggedUserAdmin = false;
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.cardIsLoading = true;
        this.mappingIndex = [];
        this.formIsLoading = false; // Used to view/hide form loading spinner
        // BEGIN - Formly config
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {
            formState: {
                disabled: false
            }
        };
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: true,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true
            }
        };
        // END - Formly config
        this.loggedUserRoleType = "";
        this.existingNotes = [];
        this.enableFormModify = false;
        this.sectionPlant = false;
        this.remakePlant = false;
        this.remakePlantDocs = {};
        this.rimappatura = false;
        this.mappaturaOpen = false;
        this.showSideMenu = true;
        this.subscriptionType = 'FREE';
        /**
         * `subscription.key` of the property for the rules of the «Esporta» menu once the switch is live:
         * `""` for a property with no plan, which the legacy treats as a paid one, `null` until the mapping
         * has loaded it, together with `subscriptionType`.
         */
        this.exportPlanKey = null;
        /** The Excel being downloaded from the new archive, `null` when none (@see exportFromArchiveV3) */
        this.exportingTarget = null;
        /** The download of that Excel, cancelled when the tab closes */
        this.exportSubscription = null;
        this.condoStructureTemplateId = "";
        this.condoStructureTemplate = [];
        this.notesExist = false;
    }
    Object.defineProperty(PropertyDetailMappingTabComponent.prototype, "downloadMenu", {
        /**
         * The entries of the «Esporta» menu as far as the switch decides them: every one, under the rules
         * of the template, until the switch; once it is live, those of the «Esporta» menu of the new
         * dossier, whose routes they then call (@see legacyPageExportMenu).
         *
         * @since 3.0.0
         */
        get: function () {
            return legacyPageExportMenu(isArchiveV3Live(), {
                roleType: this.loggedUserRoleType,
                permissions: this.loggedUserPermissions,
                subscriptionKey: this.exportPlanKey,
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyDetailMappingTabComponent.prototype, "downloadMenuShown", {
        /**
         * Whether the «Esporta» button is shown to the roles of the template: always until the switch, as
         * before; once it is live, only with at least one entry, as in the new dossier.
         *
         * @since 3.0.0
         */
        get: function () {
            return !isArchiveV3Live() || hasDocumentArchiveExportMenu(this.downloadMenu);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.ngOnInit = function () {
        var e_1, _a;
        var _this = this;
        this.mappingQrcodeData = this.configService.frontEndHost + "/qrcode-admin-mapping/" + this.condoStructure._id;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            var currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            _this.loggedUserRoleType = currentRole.role.type;
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        if (this.condoStructure) {
            for (var key in this.condoStructure) {
                if (Array.isArray(this.condoStructure[key]) &&
                    this.condoStructure[key].length) {
                    try {
                        for (var _b = (e_1 = void 0, tslib_1.__values(this.condoStructure[key])), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var el = _c.value;
                            if (el.note && Array.isArray(el.note) && el.note.length) {
                                this.notesExist = true;
                                break;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    if (this.notesExist) {
                        break;
                    }
                }
            }
        }
        if (this.property) {
            this.documentArchivesService
                .get(this.property.documentArchive)
                .subscribe(function (res) {
                if (res.status) {
                    _this.documentArchive = res.data;
                }
                // this.cardIsLoading = false;
            });
            if (this.property.admin &&
                this.property.admin.company &&
                this.property.admin.company._id) {
                this.companiesService
                    .get(this.property.admin.company._id)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.companyData = res.data;
                    }
                    else {
                        _this.toastrService.error(res.message);
                    }
                });
            }
        }
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var property = changes["property"];
        // Update property
        if (property && property.currentValue && property.currentValue._id) {
            this.property = property.currentValue;
            this.propertyId = property.currentValue._id;
        }
        // Update form section depending on current mappingFormActiveSection
        if (this.property) {
            // @NEW
            this.subscriptions.push(this.authService.loggedUserRequestedRoleType$.subscribe(function (res) {
                _this.loggedUserToleType = res;
                if (_this.loggedUserToleType === "master"
                    || _this.loggedUserToleType === "collaborator") {
                    _this.loggedUserMaster = true;
                    _this.rimappatura = false;
                    if (_this.condoStructure.rimappatura) {
                        _this.rimappatura = true;
                        _this.mappaturaOpen = _this.condoStructure.open;
                    }
                }
                else if (_this.loggedUserToleType === "admin"
                    || _this.loggedUserToleType === "operator") {
                    _this.loggedUserAdmin = true;
                    _this.rimappatura = true;
                    _this.mappaturaOpen = _this.condoStructure.open;
                }
                if (_this.loggedUserToleType === "shared") {
                    _this.loggedUserShared = true;
                }
                if (_this.loggedUserToleType === "temporary") {
                    _this.loggedUserTemporary = true;
                }
            }));
            if (this.mappingIndex.length === 0) {
                this.subscriptions.push(this.settingsService.getStructure().subscribe(function (res) {
                    if (res.status) {
                        if (res.condoStructureTemplate &&
                            Array.isArray(res.condoStructureTemplate) &&
                            res.condoStructureTemplate.length > 0 &&
                            res.condoStructureTemplate[0].area &&
                            Array.isArray(res.condoStructureTemplate[0].area)) {
                            _this.condoStructureTemplateId = res.condoStructureTemplate[0]._id;
                            _this.condoStructureTemplate = res.condoStructureTemplate[0].area;
                            var structureTemplate = JSON.parse(JSON.stringify(_this.condoStructureTemplate));
                            // hide question deleted
                            _this.mappingIndex = structureTemplate.filter(function (el) {
                                if (!el.deleted) {
                                    if (el.content && Array.isArray(el.content)) {
                                        var content = el.content.filter(function (subEl) { return !subEl.deleted; });
                                        if (content && Array.isArray(content)) {
                                            content.forEach(function (subContent) {
                                                if (subContent &&
                                                    subContent.formConfig &&
                                                    Array.isArray(subContent.formConfig) &&
                                                    subContent.formConfig.length === 1 &&
                                                    subContent.formConfig[0].fieldGroup &&
                                                    Array.isArray(subContent.formConfig[0].fieldGroup)) {
                                                    var fieldGroup = subContent.formConfig[0].fieldGroup.filter(function (group) { return !group.deleted; });
                                                    subContent.formConfig[0].fieldGroup = fieldGroup;
                                                }
                                            });
                                        }
                                        el.content = content;
                                    }
                                    return true;
                                }
                            });
                            _this.mappingIndex = _this.translateKeys2(["placeholder", "label"], _this.mappingIndex);
                            _this.updateFormSection();
                            _this.cardIsLoading = false;
                            // Check property type: Condo or BSC
                            _this.subscriptionType = _this.property.subscription.key;
                            // The plan as the rules of the exports read it once the switch is live
                            _this.exportPlanKey = typeof _this.subscriptionType === "string" ? _this.subscriptionType : "";
                            if (_this.property.type === "bsc") {
                                var strutture = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.strutture";
                                });
                                if (strutture
                                    && strutture.content
                                    && Array.isArray(strutture.content)) {
                                    var index = strutture.content.findIndex(function (item) {
                                        return item.key === "condominiBsc";
                                    });
                                    strutture.content[index].hidden = false;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "fabbricatoAbitativo";
                                    });
                                    strutture.content[index].hidden = true;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "struttureFabbindip";
                                    });
                                    strutture.content[index].hidden = false;
                                }
                                var trattamentoAcqua = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.trattamentoAcqua";
                                });
                                if (trattamentoAcqua
                                    && trattamentoAcqua.content
                                    && Array.isArray(trattamentoAcqua.content)) {
                                    var index = trattamentoAcqua.content.findIndex(function (item) {
                                        return item.key === "sottostazioneAltroCondBsc";
                                    });
                                    trattamentoAcqua.content[index].hidden = true;
                                }
                                var riscaldamentoCondizionamento = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.riscaldamentoCondizionamento";
                                });
                                if (riscaldamentoCondizionamento
                                    && riscaldamentoCondizionamento.content
                                    && Array.isArray(riscaldamentoCondizionamento.content)) {
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "sottostazioniCt"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = true;
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "centraleRicervimento"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = true;
                                    var index = riscaldamentoCondizionamento.content.findIndex(function (item) {
                                        return item.key === "cannaCollettiva";
                                    });
                                    riscaldamentoCondizionamento.content[index].hidden = true;
                                }
                                var dispositiviAntincendio = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.dispositiviAntincendio";
                                });
                                if (dispositiviAntincendio
                                    && dispositiviAntincendio.content
                                    && Array.isArray(dispositiviAntincendio.content)) {
                                    var index = dispositiviAntincendio.content.findIndex(function (item) {
                                        return item.key === "evac";
                                    });
                                    dispositiviAntincendio.content[index].hidden = true;
                                }
                            }
                            else {
                                var strutture = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.strutture";
                                });
                                if (strutture
                                    && strutture.content
                                    && Array.isArray(strutture.content)) {
                                    var index = strutture.content.findIndex(function (item) {
                                        return item.key === "condominiBsc";
                                    });
                                    strutture.content[index].hidden = true;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "fabbricatoAbitativo";
                                    });
                                    strutture.content[index].hidden = false;
                                    index = strutture.content.findIndex(function (item) {
                                        return item.key === "struttureFabbindip";
                                    });
                                    strutture.content[index].hidden = false;
                                }
                                var trattamentoAcqua = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.trattamentoAcqua";
                                });
                                if (trattamentoAcqua
                                    && trattamentoAcqua.content
                                    && Array.isArray(trattamentoAcqua.content)) {
                                    var index = trattamentoAcqua.content.findIndex(function (item) {
                                        return item.key === "sottostazioneAltroCondBsc";
                                    });
                                    trattamentoAcqua.content[index].hidden = false;
                                }
                                var riscaldamentoCondizionamento = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.riscaldamentoCondizionamento";
                                });
                                if (riscaldamentoCondizionamento
                                    && riscaldamentoCondizionamento.content
                                    && Array.isArray(riscaldamentoCondizionamento.content)) {
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "sottostazioniCt"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = false;
                                    // let index = riscaldamentoCondizionamento.content.findIndex((item: any) => {
                                    //   return item.key === "centraleRicervimento"
                                    // });
                                    // riscaldamentoCondizionamento.content[index].hidden = false;
                                    var index = riscaldamentoCondizionamento.content.findIndex(function (item) {
                                        return item.key === "cannaCollettiva";
                                    });
                                    riscaldamentoCondizionamento.content[index].hidden = false;
                                }
                                var dispositiviAntincendio = _this.mappingIndex.find(function (el) {
                                    return el.title === "properties.structures.dispositiviAntincendio";
                                });
                                if (dispositiviAntincendio
                                    && dispositiviAntincendio.content
                                    && Array.isArray(dispositiviAntincendio.content)) {
                                    var index = dispositiviAntincendio.content.findIndex(function (item) {
                                        return item.key === "evac";
                                    });
                                    dispositiviAntincendio.content[index].hidden = false;
                                }
                            }
                            _this.watchFormChanges();
                            _this.watchScaleChanges();
                            _this.watchBruciatoriChanges();
                            // Enable fields if we're adding a new element, else disable form
                            if (_this.form && _this.activeItem
                                && (!_this.formActiveSubitemId || _this.activeItem.key === "anagrafica")
                                && _this.mappaturaOpen) {
                                _this.options.formState = {
                                    disabled: false
                                };
                                _this.formBtnOptions.disabled = false;
                                _this.enableFormModify = true;
                                // Check new element and remake plant, then
                                // get save docs to import in new plant
                                if (_this.formActiveSection && !_this.formActiveSubitemId) {
                                    _this.remakePlantDocs = _this.condoStructuresService.getRemakeStrucutureDocs();
                                    // Check if same plant then remake plant.
                                    if (_this.remakePlantDocs
                                        && _this.remakePlantDocs.activeSection &&
                                        _this.remakePlantDocs.activeSection === _this.formActiveSection) {
                                        _this.remakePlant = true;
                                    }
                                    else {
                                        _this.remakePlant = false;
                                        _this.condoStructuresService.setRemakeStrucutureDocs("", "", {});
                                    }
                                }
                                if (typeof _this.model.files === "undefined") {
                                    _this.model["files"] = [];
                                }
                            }
                            else if (_this.form && _this.formActiveSubitemId) {
                                _this.options.formState = {
                                    disabled: true
                                };
                                _this.formBtnOptions.disabled = true;
                                _this.enableFormModify = false;
                            }
                        }
                    }
                }));
            }
            else {
                this.updateFormSection();
                this.cardIsLoading = false;
            }
            // @OLD
            // this.updateFormSection();
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        if (this.exportSubscription) {
            this.exportSubscription.unsubscribe();
        }
        this.onDestroy$.next();
        this.onDestroy$.complete();
    };
    /**
     * Init components
     *
     * @since 1.0.0
     */
    /**
     * Listen on form values changes
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.watchFormChanges = function () {
        var _this = this;
        this.subscriptions.push(this.form.valueChanges.subscribe(function (res) {
            if (res && JSON.stringify(res) === _this.previousFormValue) {
                return;
            }
            else {
                _this.previousFormValue = JSON.stringify(res);
                if (_this.enableFormModify) {
                    _this.options.formState = {
                        disabled: false,
                    };
                    _this.form.updateValueAndValidity();
                }
                return;
            }
        }));
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.watchScaleChanges = function () {
        var _this = this;
        this.mappingIndex = this.mappingIndex.map(function (item) {
            // Our goal here is to add a event listener to the item we are searching for
            if (item.title === "properties.structures.strutture" &&
                Array.isArray(item.content)) {
                item.content.map(function (subItem) {
                    if (subItem.key === "fabbricatoAbitativo" &&
                        subItem.formConfig &&
                        subItem.formConfig.length &&
                        subItem.formConfig[0].fieldGroup) {
                        var field = subItem.formConfig[0].fieldGroup.find(function (el) { return el.key === "nscale"; });
                        if (field) {
                            field.hooks = {
                                onInit: function (field) {
                                    field.formControl.valueChanges
                                        .pipe(takeUntil(_this.onDestroy$), startWith(field.formControl.value), tap(function (value) {
                                        if (typeof value === "undefined") {
                                            value = null;
                                        }
                                        if (value > field.templateOptions.max) {
                                            value = field.templateOptions.max;
                                        }
                                        if (_this.model.scale) {
                                            _this.model.scale.length = value;
                                        }
                                        _this.model = tslib_1.__assign({}, _this.model, { nscale: value });
                                    }))
                                        .subscribe();
                                }
                            };
                        }
                    }
                    return subItem;
                });
            }
            return item;
        });
    };
    /**
     * Listen on input values changes
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.watchBruciatoriChanges = function () {
        var _this = this;
        this.mappingIndex = this.mappingIndex.map(function (item) {
            // Our goal here is to add a event listener to the item we are searching for
            if (item.title === "properties.structures.riscaldamentoCondizionamento" &&
                Array.isArray(item.content)) {
                item.content.map(function (subItem) {
                    if (subItem.key === "centraleTermica" &&
                        subItem.formConfig &&
                        subItem.formConfig.length &&
                        subItem.formConfig[0].fieldGroup) {
                        var field = subItem.formConfig[0].fieldGroup.find(function (el) { return el.key === "numeroBruciatori"; });
                        if (field) {
                            field.hooks = {
                                onInit: function (field) {
                                    field.formControl.valueChanges
                                        .pipe(takeUntil(_this.onDestroy$), startWith(field.formControl.value), tap(function (value) {
                                        if (typeof value === "undefined") {
                                            value = null;
                                        }
                                        if (value > field.templateOptions.max) {
                                            value = field.templateOptions.max;
                                        }
                                        _this.model.bruciatori.length = value;
                                        _this.model = tslib_1.__assign({}, _this.model, { numeroBruciatori: value });
                                    }))
                                        .subscribe();
                                }
                            };
                        }
                    }
                    return subItem;
                });
            }
            return item;
        });
    };
    /**
     * Translate all keys with given labels inside given object and returns it
     *
     * @since 4.0.0
     */
    PropertyDetailMappingTabComponent.prototype.translateKeys = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                for (var prop in item) {
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            item[prop] = _this.translateService.instant(item[prop]);
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys(keys, item[prop]);
                        }
                    }
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    // @NEW
    // hooks: {
    //   onInit(field: any) {
    //     field.defaultValue = `Scala ${+field.parent.key + 1}`; // formArray index + 1
    //   },
    // },
    // hooks: {
    //   onInit(field: any) {
    //     field.defaultValue = `Bruciatore ${
    //       +field.parent.key + 1
    //     }`; // formArray index + 1
    //   },
    // },
    PropertyDetailMappingTabComponent.prototype.translateKeys2 = function (keys, obj) {
        var _this = this;
        if (Array.isArray(obj)) {
            obj.forEach(function (item) {
                var _loop_1 = function (prop) {
                    // hooks: 
                    // 1) numerazione progressiva all'aggiunta delle scale del Fabbricato abitativo
                    // 2) numerazione progressiva all'aggiunta dei bruciatori di Centrale termica
                    if (prop === "hooks") {
                        var propKey_1 = item[prop];
                        item[prop] = {
                            onInit: function (field) {
                                field.defaultValue = propKey_1 + " " + (+field.parent.key + 1);
                            },
                        };
                    }
                    // hideExpression: 
                    // nasconde il corrente campo se il valore del campo indicato soddisfa i criteri indicati da "operator"
                    // e diabilita l'obbligatorietà del campo in "templateOptions.required"
                    if (prop === "hideExpression" && item[prop]) {
                        var propKey_2 = item[prop].key;
                        var propCompareValue_1 = item[prop].value;
                        if (item[prop].operator === "!==") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return currentValue !== compareValue;
                            };
                        }
                        else if (item[prop].operator === "!") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                return !currentValue;
                            };
                        }
                        else if (item[prop].operator === "!includes") {
                            item[prop] = function (model, formState, field) {
                                var key = propKey_2;
                                var currentValue = model[key];
                                var compareValue = propCompareValue_1;
                                return typeof currentValue === "undefined" || !currentValue.includes(compareValue);
                            };
                        }
                    }
                    // expressionProperties:
                    // Contatore energia elettrica:
                    // disabilita il campo "connessioni" e/o "alimenta un singolo impianto" 
                    // usato in "templateOptions.disabled"
                    if (prop === "expressionProperties" && item[prop]) {
                        var propDisabled = item[prop].disabled;
                        if (propDisabled !== "formState.disabled" &&
                            propDisabled !== "connessioni" &&
                            propDisabled !== "") {
                            var key_1 = propDisabled;
                            propDisabled = function (model, formState, field) {
                                return model[key_1] || formState.disabled;
                            };
                        }
                        else if (propDisabled === "connessioni") {
                            var key_2 = propDisabled;
                            propDisabled = function (model, formState, field) {
                                if (model[key_2] === "undefined") {
                                    return false;
                                }
                                else if (Array.isArray(model[key_2]) && model[key_2].length > 0) {
                                    return true;
                                }
                                return false;
                            };
                        }
                        if (typeof item[prop].required !== "undefined") {
                            var propKey_3 = item[prop].required.key;
                            var propCompareValue_2 = item[prop].required.value;
                            if (item[prop].required.operator === "===") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        var compareValue = propCompareValue_2;
                                        return currentValue === compareValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "!") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return !currentValue;
                                    }
                                };
                            }
                            else if (item[prop].required.operator === "") {
                                item[prop] = {
                                    "templateOptions.disabled": propDisabled,
                                    "templateOptions.required": function (model, formState, field) {
                                        var key = propKey_3;
                                        var currentValue = model[key];
                                        return currentValue;
                                    }
                                };
                            }
                        }
                        else {
                            item[prop] = {
                                "templateOptions.disabled": propDisabled,
                            };
                        }
                    }
                    // defaultValue:
                    // contiene il valore predefinito del campo corrente
                    if (prop === "defaultValue" && item[prop]) {
                        if (item[prop] === "false") {
                            item[prop] = false;
                        }
                        else if (item[prop] === "true") {
                            item[prop] = true;
                        }
                    }
                    // wrappers:
                    // struttura del titolo/campo nel form: orizzontale/verticale  
                    // oppure in assenza di "key" e in presenza di "template" => visualizza contenuto di "template"
                    if (prop === "wrappers" && item[prop] && Array.isArray(item[prop]) && item[prop].length === 0) {
                        item[prop] = "";
                    }
                    if (item.hasOwnProperty(prop)) {
                        if (keys.includes(prop)) {
                            if (item["translation"]) {
                                item[prop] = item["translation"].it;
                            }
                        }
                        if (typeof item[prop] === "object") {
                            item[prop] = _this.translateKeys2(keys, item[prop]);
                        }
                    }
                };
                for (var prop in item) {
                    _loop_1(prop);
                }
            });
        }
        else {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    // options:
                    // in "templateOptions" e
                    // contiene l'elenco dei valori del campo di tipo select (value/translation)
                    if (prop === "options" && Array.isArray(obj[prop])) {
                        obj[prop].forEach(function (elem) {
                            if (elem.value && elem.value === "true") {
                                elem.value = true;
                            }
                            else if (elem.value && elem.value === "false") {
                                elem.value = false;
                            }
                        });
                    }
                    if (keys.includes(prop) && obj[prop]) {
                        obj[prop] = this.translateService.instant(obj[prop]);
                        if (prop === "label" && obj["translationLabel"]) {
                            obj[prop] = obj["translationLabel"].it;
                        }
                        else if (prop === "placeholder" && obj["translationPlaceholder"]) {
                            obj[prop] = obj["translationPlaceholder"].it;
                        }
                    }
                    if (typeof obj[prop] === "object") {
                        obj[prop] = this.translateKeys2(keys, obj[prop]);
                    }
                }
            }
        }
        return obj;
    };
    /**
     * Get children (existing values) for requested section
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.getChildren = function (key) {
        if (typeof this.condoStructure !== "undefined"
            && typeof this.condoStructure[key] !== "undefined") {
            if (key === "anagrafica") {
                return [];
            }
            else {
                if (Array.isArray(this.condoStructure[key])) {
                    var structures = JSON.parse(JSON.stringify(this.condoStructure[key]));
                    structures = structures.filter(function (el) { return el.active; });
                    return structures;
                }
                else {
                    return [];
                }
            }
        }
        return [];
    };
    /**
     * Update form section depending on route params
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.updateFormSection = function () {
        var _this = this;
        // Reset model to prevent import previous form data
        if (this.model) {
            for (var property in this.model) {
                delete this.model[property];
            }
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        // Reset data and call the new data form
        if (this.form) {
            this.options.formState = {
                disabled: true
            };
        }
        // Add section param to routing, which is used in connections type
        var params = Object.assign({}, this.activatedRoute.snapshot.params, { selected: false });
        params.mappingFormActiveSection = this.formActiveSection;
        this.activatedRoute.snapshot.params = params;
        if (this.formActiveSection) {
            this.formIsLoading = true; // Start form loading
            // BEGIN - Set open status to current mapping index
            var origFormActiveSection_1 = this.formActiveSection.replace(this.property.structure, ":structureId");
            this.mappingIndex.map(function (item) {
                item.content.map(function (subItem) {
                    if (subItem.section === origFormActiveSection_1) {
                        // Get currente element is a Plant
                        // delete note field from form
                        // if (subItem.formConfig
                        //   && Array.isArray(subItem.formConfig)
                        //   && subItem.formConfig.length) {
                        //   if (subItem.formConfig[0].fieldGroup
                        //     && Array.isArray(subItem.formConfig[0].fieldGroup)
                        //     && subItem.formConfig[0].fieldGroup.length) {
                        //     const index = subItem.formConfig[0].fieldGroup.findIndex((el: any) => {
                        //       return el.key === "note";
                        //     })
                        //     if (index > -1) {
                        //       subItem.formConfig[0].fieldGroup.splice(index, 1);
                        //     }
                        //   }
                        // }
                        if (item.title === "properties.structures.impiantiElettrici" ||
                            item.title === "properties.structures.trattamentoAcqua" ||
                            item.title ===
                                "properties.structures.riscaldamentoCondizionamento" ||
                            item.title === "properties.structures.dispositiviAntincendio" ||
                            item.title === "properties.structures.ascensoriEMontauto" ||
                            item.title === "properties.structures.impiantiElettronici" ||
                            item.title === "properties.structures.lineeVita" ||
                            item.title === "properties.structures.impiantiSpeciali" ||
                            item.title === "properties.structures.impiantiRicreativi") {
                            _this.sectionPlant = true;
                        }
                        else {
                            _this.sectionPlant = false;
                        }
                        item.expanded = true;
                        subItem.expanded = true;
                        subItem.active = true;
                        _this.activeItem = subItem;
                        if (_this.formActiveSection &&
                            origFormActiveSection_1 !==
                                "condo-structures/:structureId/anagrafica") {
                            var children = _this.getChildren(subItem.key);
                            if (children.length) {
                                _this.activeSubitem = children.find(function (val) { return val._id === _this.formActiveSubitemId; });
                                if (_this.activeSubitem && _this.activeSubitem.files) {
                                    if (_this.form.controls.files) {
                                        _this.form.controls.files.setValue(_this.activeSubitem.files);
                                    }
                                    _this.form.updateValueAndValidity();
                                }
                                if (_this.activeSubitem && _this.activeSubitem.note) {
                                    _this.existingNotes = _this.activeSubitem.note;
                                    _this.activeSubitem.note = null;
                                }
                                _this.fields = subItem.formConfig;
                                if (_this.activeSubitem) {
                                    _this.model = Object.assign({ subscription: {} }, _this.activeSubitem);
                                }
                                else {
                                    // Add new subitem. Default name from section
                                    var tot = children.length + 1;
                                    var nome = subItem.translation.it + " " + tot;
                                    // this.translateService.instant(subItem.title) + " " + tot;
                                    _this.model = { nome: nome, files: [], subscription: {} };
                                    // Delete defaultValue from field Files, to clear previous upload image
                                    if (subItem.formConfig
                                        && Array.isArray(subItem.formConfig)
                                        && subItem.formConfig.length) {
                                        if (subItem.formConfig[0].fieldGroup
                                            && Array.isArray(subItem.formConfig[0].fieldGroup)
                                            && subItem.formConfig[0].fieldGroup.length) {
                                            var index = subItem.formConfig[0].fieldGroup.findIndex(function (el) {
                                                return el.key === "files";
                                            });
                                            if (index > -1) {
                                                if (subItem.formConfig[0].fieldGroup[index].templateOptions
                                                    && Array.isArray(subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue)
                                                    && subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue.length) {
                                                    subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue = [];
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                if (_this.activeSubitem && _this.activeSubitem.note) {
                                    _this.existingNotes = _this.activeSubitem.note;
                                    _this.activeSubitem.note = null;
                                }
                                // New first subitem. Default name from section
                                _this.fields = subItem.formConfig;
                                var nome = subItem.translation.it + " 1";
                                // this.translateService.instant(subItem.title) + " 1";
                                _this.model = { nome: nome, files: [], subscription: {} };
                                // Delete defaultValue from field Files, to clear previous upload image
                                if (subItem.formConfig
                                    && Array.isArray(subItem.formConfig)
                                    && subItem.formConfig.length) {
                                    if (subItem.formConfig[0].fieldGroup
                                        && Array.isArray(subItem.formConfig[0].fieldGroup)
                                        && subItem.formConfig[0].fieldGroup.length) {
                                        var index = subItem.formConfig[0].fieldGroup.findIndex(function (el) {
                                            return el.key === "files";
                                        });
                                        if (index > -1) {
                                            if (subItem.formConfig[0].fieldGroup[index].templateOptions
                                                && Array.isArray(subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue)
                                                && subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue.length) {
                                                subItem.formConfig[0].fieldGroup[index].templateOptions.defaultValue = [];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else if (subItem.section === "condo-structures/:structureId/anagrafica") {
                            _this.activeSubitem = _this.condoStructure.anagrafica;
                            // Anagrafica: is not completed
                            if (typeof _this.activeSubitem === "undefined") {
                                _this.activeSubitem = {
                                    active: true
                                };
                            }
                            if (_this.activeSubitem && _this.activeSubitem.note) {
                                _this.existingNotes = _this.activeSubitem.note;
                                _this.activeSubitem.note = null;
                            }
                            _this.fields = subItem.formConfig;
                            _this.model = Object.assign({ subscription: {} }, _this.activeSubitem);
                            _this.formActiveSubitemId = Math.random().toString();
                        }
                    }
                    else {
                        subItem.active = false;
                    }
                });
            });
            if (this.form && !this.condoStructure.open) {
                this.options.formState = {
                    disabled: true
                };
            }
            // END - Set open status to current mapping index
            setTimeout(function () {
                _this.formIsLoading = false;
            }, 300);
        }
        else {
            // Reset the last item.expanded mappingIndex to close tree from previous structure
            if (Array.isArray(this.mappingIndex) && this.mappingIndex.length) {
                this.mappingIndex.forEach(function (item) {
                    if (item.expanded) {
                        item.expanded = false;
                        if (Array.isArray(item.content) && item.content.length) {
                            item.content.forEach(function (elem) {
                                if (elem.active) {
                                    elem.active = false;
                                }
                            });
                        }
                    }
                });
            }
        }
    };
    /**
     * Navigate to given section inside the same property detail page
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.activateSection = function (rawSection) {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        // Return if we're trying to navigate to 'anagrafica' but
        // we're already in that route
        if (rawSection.endsWith('anagrafica')) {
            if (this.activatedRoute.snapshot.params.mappingFormActiveSection
                && this.activatedRoute.snapshot.params.mappingFormActiveSection.endsWith('anagrafica')) {
                return;
            }
        }
        var section = rawSection.replace(":structureId", this.property.structure);
        // Already on this section's "new element" form: the router ignores a navigation
        // to the URL it is already on, so the form would not be rebuilt. Removing its
        // controls here would leave the fields on screen but detached from `form`, and
        // Formly re-attaches only the fields that later change visibility: the POST
        // would carry just those (e.g. only `superficiemqr3`) or nothing at all
        if (!this.formActiveSubitemId && this.formActiveSection === section) {
            return;
        }
        // Reset data and call the new data form
        this.formActiveSubitemId = undefined;
        var controls = this.form.controls;
        for (var key in controls) {
            this.form.removeControl(key);
        }
        this.formActiveSubitemId = "";
        this.formActiveSection = section;
        this.router.navigate([this.lang, "app", "properties", this.property._id, "mapping", section], {
            replaceUrl: true,
        });
    };
    /**
     * Handle panel header open/close
     *
     * @since 1.0.0
     *
     */
    PropertyDetailMappingTabComponent.prototype.onPanelClicked = function (item, index) {
        item.expanded = !item.expanded;
        this.mappingIndex.forEach(function (el, i) {
            if (i !== index) {
                el.expanded = false;
            }
        });
        // Handle scroll to panel
        if (item.expanded) {
            var headerHeight = 60;
            var top_1 = (headerHeight * (index + 1)) - headerHeight;
            window.scrollTo({
                top: top_1,
                behavior: "smooth"
            });
        }
    };
    /**
     * Handle form item click and open view/edit popup
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onFormItemClick = function (rawSection, item) {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        var itemId = "";
        if (item && item._id) {
            itemId = item._id;
        }
        var section = rawSection.replace(":structureId", this.property.structure);
        if (rawSection !== 'condo-structures/:structureId/anagrafica') {
            this.enableFormModify = false;
        }
        // @todo: this causes unwanted page reload (page content disappears)
        this.router.navigate([
            this.lang,
            "app",
            "properties",
            this.property._id,
            "mapping",
            section,
            itemId
        ], {
            replaceUrl: true
        });
        // if (this.form.dirty && !this.form.pristine) {
        //   const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
        //     minWidth: '50%',
        //     maxHeight: '98vh',
        //     data: {
        //       title: this.translateService.instant('common.warnings.warning'),
        //       message: this.translateService.instant('common.warnings.unsavedData'),
        //       btnOkText: this.translateService.instant('common.cta.continue'),
        //       btnCancelText: this.translateService.instant('common.cta.undo'),
        //       // btnCancelIcon: 'fa-times-circle',
        //     },
        //     disableClose: true,
        //   });
        //   // Subscribe to dialog result (only for 1 emit thanks to "take()")
        //   confirmDialogRef.beforeClosed()
        //     .pipe(
        //       take(1)
        //     )
        //     .subscribe(
        //       res => {
        //         if (!res) {
        //           return;
        //         }
        //         window.scrollTo({
        //           top: 0,
        //           behavior: "smooth"
        //         });
        //         const section = rawSection.replace(":structureId", this.property.structure);
        //         this.enableFormModify = false;
        //         this.router.navigate(
        //           [
        //             this.lang,
        //             "app",
        //             "properties",
        //             this.property._id,
        //             "mapping",
        //             section,
        //             item._id
        //           ],
        //           {
        //             replaceUrl: true
        //           }
        //         );
        //       }
        //     );
        //   return;
        // }
        // // @todo would be nice to check if current form has been changed and not saved and, if so, just block the navigation
        // setTimeout(() => {
        //   const headerOffset = 70;
        //   const bodyRect = document.body.getBoundingClientRect().top;
        //   const elementRect = this.card.nativeElement.getBoundingClientRect().top;
        //   const elementPosition = elementRect - bodyRect;
        //   const offsetPosition = elementPosition - headerOffset;
        //   window.scrollTo({
        //     top: offsetPosition,
        //     behavior: "smooth"
        //   });
        //   const section = rawSection.replace(
        //     ":structureId",
        //     this.property.structure
        //   );
        //   // Navigate to the new route
        //   this.router.navigate([
        //     this.lang,
        //     "app",
        //     "properties",
        //     this.property._id,
        //     "mapping",
        //     section,
        //     item._id
        //   ]);
        // }, 50);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onFormSubmit = function (model, newItem) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            console.warn("form", this.form);
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        // Update existing item
        if ((!newItem && this.model._id) ||
            this.activeItem.section === 'condo-structures/:structureId/anagrafica') {
            this.subscriptions.push(this.condoStructuresService
                .updateSection(this.activeItem.section, this.property.structure, this.model._id, this.form.value, this.mappaturaOpen)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res.status) {
                    _this.toastrService.success(res.message);
                    // Disable form
                    if (_this.form && _this.activeItem.key !== 'anagrafica') {
                        _this.options.formState = {
                            disabled: true
                        };
                        _this.formBtnOptions.disabled = true;
                        _this.enableFormModify = false;
                    }
                    if (model.note) {
                        var newNoteData = {
                            text: model.note,
                            createdAt: new Date(),
                            createdBy: _this.loggedUser._id
                        };
                        _this.existingNotes.push(newNoteData);
                        _this.model.note = '';
                        var index = _this.fields[0].fieldGroup.findIndex(function (el) {
                            return el.key == 'note';
                        });
                        _this.fields[0].fieldGroup[index].formControl.setValue('');
                    }
                    if (_this.model.files) {
                        _this.model.files = res.files;
                        if (_this.condoStructure &&
                            _this.condoStructure[_this.activeItem.key] &&
                            Array.isArray(_this.condoStructure[_this.activeItem.key])) {
                            var structureIndex = _this.condoStructure[_this.activeItem.key].findIndex(function (el) { return el._id.toString() === _this.formActiveSubitemId.toString(); });
                            if (structureIndex > -1) {
                                _this.condoStructure[_this.activeItem.key][structureIndex].files = res.files;
                            }
                        }
                    }
                    _this.onFormItemClick(_this.activeItem.section, res.item);
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                // this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        }
        else {
            var sendData = this.form.value;
            if (this.remakePlant) {
                sendData["remakePlant"] = true;
                sendData["remakePlantDocs"] = this.remakePlantDocs;
            }
            this.subscriptions.push(this.condoStructuresService
                .createSectionItem(this.activeItem.section, this.property.structure, sendData)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res.status) {
                    _this.toastrService.success(res.message);
                    if (_this.remakePlant) {
                        _this.condoStructuresService.setRemakeStrucutureDocs("", "", {});
                    }
                    // @todo:
                    // 1) Resettare il form
                    // 2) Pushare elemento creato (con dati derivanti da BE perché cosi abbiamo l'ID) negli elementi esistenti
                    // 3) Fare redirect alla route di edit/view dell'elemento appena creato
                    // condo-structures/:structureId/fabbricato-abitativo
                    // onFormItemClick(rawSection: string, item: any)
                    // item._id
                    _this.condoStructure[_this.activeItem.key].push(res.item);
                    if (res.item && res.item._id && res.item.structureId) {
                        res.item._id = res.item.structureId;
                    }
                    _this.onFormItemClick(_this.activeItem.section, res.item);
                }
                else {
                    // @todo gestire errore! Maybe just a toaster.error
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                // this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        }
    };
    /**
     * Check if given macr-section item is visibile or not depending on
     * structure open status. If structure is open, than this will always returns true
     * If it's false, this will check if at least one sub-section has one or more
     * values. If so, return true, otherwise return false;
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.checkVisibility = function (item) {
        var _this = this;
        if (!this.mappaturaOpen) {
            if (item.content && item.content.length) {
                // Let's make anagrafica section ALWAYS visible
                if (item.content[0].key === "anagrafica") {
                    return true;
                }
                return item.content.some(function (subitem) { return _this.getChildren(subitem.key).length; });
            }
            return false;
        }
        return true;
    };
    /**
     * Handle click on "open" or "close" mapping buttons
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onToggleStructure = function (action) {
        var _this = this;
        var message = action === "open"
            ? this.translateService.instant("properties.detail.mappingTab.confirmDialog.confirmOpening")
            : this.translateService.instant("properties.detail.mappingTab.confirmDialog.confirmClosing");
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: message,
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo")
            },
            width: "500px"
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                _this.cardIsLoading = true;
                var data_1 = {};
                if (action === "open") {
                    data_1.open = true;
                }
                else {
                    data_1.open = false;
                    // Close item menu opened
                    _this.mappingIndex.map(function (item) {
                        item.content.map(function (subItem) {
                            subItem.expanded = false;
                        });
                        item.expanded = false;
                    });
                }
                _this.subscriptions.push(_this.condoStructuresService
                    .update(_this.condoStructure._id, data_1)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.toastrService.success(res.message);
                        _this.cardIsLoading = false;
                        _this.condoStructure.open = data_1.open;
                        _this.mappaturaOpen = _this.condoStructure.open;
                        if (data_1.open && _this.form) {
                            _this.options.formState = {
                                disabled: false
                            };
                            _this.formBtnOptions.disabled = false;
                            _this.enableFormModify = true;
                        }
                        if (!data_1.open && _this.form) {
                            _this.options.formState = {
                                disabled: true
                            };
                            _this.formBtnOptions.disabled = true;
                            _this.enableFormModify = false;
                        }
                        _this.router.navigate([
                            _this.lang,
                            "app",
                            "properties",
                            _this.property._id,
                            "mapping",
                        ], {
                            replaceUrl: true
                        });
                    }
                    else {
                        _this.toastrService.error(res.message);
                        _this.cardIsLoading = false;
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                }));
            }
        });
    };
    /**
     * Enable form to edit structure (not for anagrafica)
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onEnableEdit = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("properties.structures.textConfimFormModify"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo")
            },
            width: "500px"
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                _this.enableFormModify = true;
                if (_this.form) {
                    _this.options.formState = {
                        disabled: false
                    };
                    _this.formBtnOptions.disabled = false;
                    _this.enableFormModify = true;
                }
            }
        });
    };
    /**
     * Open delete plant dialog
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onDeleteDialog = function () {
        var _this = this;
        // With the 3.0.0 archive switched on, the documents come from it (MAP-A1)
        if (isArchiveV3Live()) {
            this.onArchiveV3DeleteDialog();
            return;
        }
        var message = "properties.structures.textConfimFormDeletePlant";
        var docs = this.getDocsFromArchive(this.activeItem.key, this.formActiveSubitemId);
        var dialogRef = this.dialog.open(PropertyDetailMappingDeleteDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant(message),
                docs: docs,
                propertyId: this.propertyId,
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
                sectionPlant: this.sectionPlant,
                subscriptionType: this.subscriptionType,
            },
            width: "800px"
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                _this.subscriptions.push(_this.condoStructuresService
                    .deleteSection(_this.activeItem.section, _this.property.structure, _this.formActiveSubitemId)
                    .subscribe(function (resDel) {
                    if (resDel.status) {
                        _this.toastrService.success(resDel.message);
                        _this.router.navigate([
                            _this.lang,
                            "app",
                            "properties",
                            _this.property._id,
                            "mapping",
                        ], {
                            replaceUrl: true
                        });
                    }
                    else {
                        _this.toastrService.error(resDel.message);
                    }
                }));
            }
        });
    };
    /**
     * Get docs from archive per structure
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.getDocsFromArchive = function (itemKey, itemId) {
        var e_2, _a;
        var docs = {};
        switch (itemKey) {
            case "fabbricatoAbitativo":
                break;
            case "struttureFabbindip":
                break;
            case "compartimentoBox":
                break;
            case "portineriaGuardiola":
                break;
            case "appartCustode":
                break;
            case "giardini":
                break;
            case "cortili":
                break;
            case "unitaAbitativaCommerciale":
                break;
            case "unitaImmIndipendente":
                break;
            case "gruppoElettrogeno":
                if (this.documentArchive.impeleGruppoElettrogeno
                    && Array.isArray(this.documentArchive.impeleGruppoElettrogeno)) {
                    docs = this.documentArchive.impeleGruppoElettrogeno.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "fotovoltaico":
                if (this.documentArchive.impeleFotovoltaico
                    && Array.isArray(this.documentArchive.impeleFotovoltaico)) {
                    docs = this.documentArchive.impeleFotovoltaico.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "scaricheAtmosferiche":
                if (this.documentArchive.impelescaricheAtmosferiche
                    && Array.isArray(this.documentArchive.impelescaricheAtmosferiche)) {
                    docs = this.documentArchive.impelescaricheAtmosferiche.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "centraleIdricaPropria":
                if (this.documentArchive.tratAcquaCentraleIdrica
                    && Array.isArray(this.documentArchive.tratAcquaCentraleIdrica)) {
                    docs = this.documentArchive.tratAcquaCentraleIdrica.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "contatoriAcqua":
                if (this.documentArchive.tratAcquaContatoreAcqua
                    && Array.isArray(this.documentArchive.tratAcquaContatoreAcqua)) {
                    docs = this.documentArchive.tratAcquaContatoreAcqua.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "sottostazioneAltroCondBsc":
                if (this.documentArchive.tratAcquaSottAlimDaBsc
                    && Array.isArray(this.documentArchive.tratAcquaSottAlimDaBsc)) {
                    docs = this.documentArchive.tratAcquaSottAlimDaBsc.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "sollevamAcquePiovNere":
                if (this.documentArchive.tratAcquaPompSollacqpiov
                    && Array.isArray(this.documentArchive.tratAcquaPompSollacqpiov)) {
                    docs = this.documentArchive.tratAcquaPompSollacqpiov.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "contatoreGas":
                if (this.documentArchive.riscaldgasMetcontatrete
                    && Array.isArray(this.documentArchive.riscaldgasMetcontatrete)) {
                    docs = this.documentArchive.riscaldgasMetcontatrete.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "serbatoiAGasolio":
                if (this.documentArchive.serbatoioAGasolio
                    && Array.isArray(this.documentArchive.serbatoioAGasolio)) {
                    docs = this.documentArchive.serbatoioAGasolio.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "centraleTermica":
                if (this.documentArchive.riscaldrisccentraliz
                    && Array.isArray(this.documentArchive.riscaldrisccentraliz)) {
                    docs = this.documentArchive.riscaldrisccentraliz.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "cannaFumaria":
                if (this.documentArchive.riscaldcanneFumariePerCt
                    && Array.isArray(this.documentArchive.riscaldcanneFumariePerCt)) {
                    docs = this.documentArchive.riscaldcanneFumariePerCt.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "sottostazioniCt":
                if (this.documentArchive.riscaldsottostazriscaldamen
                    && Array.isArray(this.documentArchive.riscaldsottostazriscaldamen)) {
                    docs = this.documentArchive.riscaldsottostazriscaldamen.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "solareTermico":
                if (this.documentArchive.riscaldsolareTermico
                    && Array.isArray(this.documentArchive.riscaldsolareTermico)) {
                    docs = this.documentArchive.riscaldsolareTermico.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "teleriscaldamento":
                if (this.documentArchive.riscaldcentrteleriscaldamen
                    && Array.isArray(this.documentArchive.riscaldcentrteleriscaldamen)) {
                    docs = this.documentArchive.riscaldcentrteleriscaldamen.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "geotermicoConPozzi":
                if (this.documentArchive.riscGeotermicoPozzi
                    && Array.isArray(this.documentArchive.riscGeotermicoPozzi)) {
                    docs = this.documentArchive.riscGeotermicoPozzi.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "geotermicoConSonde":
                if (this.documentArchive.riscGeotermicoSonde
                    && Array.isArray(this.documentArchive.riscGeotermicoSonde)) {
                    docs = this.documentArchive.riscGeotermicoSonde.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "pompeDiCalore":
                if (this.documentArchive.riscaldsoloPompeDiCalore
                    && Array.isArray(this.documentArchive.riscaldsoloPompeDiCalore)) {
                    docs = this.documentArchive.riscaldsoloPompeDiCalore.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "centraleRicervimento":
                if (this.documentArchive.riscaldcentrRicevBsc
                    && Array.isArray(this.documentArchive.riscaldcentrRicevBsc)) {
                    docs = this.documentArchive.riscaldcentrRicevBsc.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "climatizzazione":
                if (this.documentArchive.riscaldimpcondizionamento
                    && Array.isArray(this.documentArchive.riscaldimpcondizionamento)) {
                    docs = this.documentArchive.riscaldimpcondizionamento.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "estintori":
                if (this.documentArchive.incendioEstintori
                    && Array.isArray(this.documentArchive.incendioEstintori)) {
                    docs = this.documentArchive.incendioEstintori.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "reteIdranti":
                if (this.documentArchive.incendioReteIdranti
                    && Array.isArray(this.documentArchive.incendioReteIdranti)) {
                    docs = this.documentArchive.incendioReteIdranti.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "reteSprinkler":
                if (this.documentArchive.incendioReteSprinkler
                    && Array.isArray(this.documentArchive.incendioReteSprinkler)) {
                    docs = this.documentArchive.incendioReteSprinkler.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "stazionePompaggio":
                if (this.documentArchive.incendioStazionePompaggio
                    && Array.isArray(this.documentArchive.incendioStazionePompaggio)) {
                    docs = this.documentArchive.incendioStazionePompaggio.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "rilevazioneFumi":
                if (this.documentArchive.incendioRilevazione
                    && Array.isArray(this.documentArchive.incendioRilevazione)) {
                    docs = this.documentArchive.incendioRilevazione.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "ventilazione":
                if (this.documentArchive.incendioVentilazione
                    && Array.isArray(this.documentArchive.incendioVentilazione)) {
                    docs = this.documentArchive.incendioVentilazione.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "evac":
                if (this.documentArchive.incendioEvac
                    && Array.isArray(this.documentArchive.incendioEvac)) {
                    docs = this.documentArchive.incendioEvac.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "ascensore":
                if (this.documentArchive.ascensoriEMontautoAscensori
                    && Array.isArray(this.documentArchive.ascensoriEMontautoAscensori)) {
                    docs = this.documentArchive.ascensoriEMontautoAscensori.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "montauto":
                if (this.documentArchive.ascensoriEMontautoMontauto
                    && Array.isArray(this.documentArchive.ascensoriEMontautoMontauto)) {
                    docs = this.documentArchive.ascensoriEMontautoMontauto.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "tvTerrestre":
                if (this.documentArchive.impElettronicitvTerrestre
                    && Array.isArray(this.documentArchive.impElettronicitvTerrestre)) {
                    docs = this.documentArchive.impElettronicitvTerrestre.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "tvSatellitare":
                if (this.documentArchive.impElettronicitvSatellitare
                    && Array.isArray(this.documentArchive.impElettronicitvSatellitare)) {
                    docs = this.documentArchive.impElettronicitvSatellitare.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "citoVideo":
                if (this.documentArchive.impElettroniciimpCitofonico
                    && Array.isArray(this.documentArchive.impElettroniciimpCitofonico)) {
                    docs = this.documentArchive.impElettroniciimpCitofonico.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "tvCc":
                if (this.documentArchive.impElettroniciimpiantoTvcc
                    && Array.isArray(this.documentArchive.impElettroniciimpiantoTvcc)) {
                    docs = this.documentArchive.impElettroniciimpiantoTvcc.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "automazCancelli":
                if (this.documentArchive.impElettroniciautomazioni
                    && Array.isArray(this.documentArchive.impElettroniciautomazioni)) {
                    docs = this.documentArchive.impElettroniciautomazioni.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "impAntintrusione":
                if (this.documentArchive.impElettroniciantintrusione
                    && Array.isArray(this.documentArchive.impElettroniciantintrusione)) {
                    docs = this.documentArchive.impElettroniciantintrusione.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "lineeVita":
                if (this.documentArchive.lineaVita
                    && Array.isArray(this.documentArchive.lineaVita)) {
                    docs = this.documentArchive.lineaVita.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "cannaCollettiva":
                if (this.documentArchive.risccanneFumarieColl
                    && Array.isArray(this.documentArchive.risccanneFumarieColl)) {
                    docs = this.documentArchive.risccanneFumarieColl.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "amianto":
                break;
            case "dipendenti":
                break;
            case "impresePulizia":
                break;
            case "impiantoSpeciale":
                if (this.documentArchive.impiantiSpeciali
                    && Array.isArray(this.documentArchive.impiantiSpeciali)) {
                    docs = this.documentArchive.impiantiSpeciali.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "attivitavvf":
                break;
            case "piscina":
                if (this.documentArchive.impricreativipiscina
                    && Array.isArray(this.documentArchive.impricreativipiscina)) {
                    docs = this.documentArchive.impricreativipiscina.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "palestra":
                if (this.documentArchive.impricreativipalestra
                    && Array.isArray(this.documentArchive.impricreativipalestra)) {
                    docs = this.documentArchive.impricreativipalestra.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "campoTennis":
                if (this.documentArchive.impricreativicampoTennis
                    && Array.isArray(this.documentArchive.impricreativicampoTennis)) {
                    docs = this.documentArchive.impricreativicampoTennis.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "campoCalcio":
                if (this.documentArchive.impricreativicampoCalcio
                    && Array.isArray(this.documentArchive.impricreativicampoCalcio)) {
                    docs = this.documentArchive.impricreativicampoCalcio.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
            case "parcoGiochi":
                if (this.documentArchive.impricreativiparcoGiochi
                    && Array.isArray(this.documentArchive.impricreativiparcoGiochi)) {
                    docs = this.documentArchive.impricreativiparcoGiochi.find(function (el) {
                        return itemId === el.structureObjectId;
                    });
                }
                break;
        }
        // Fallback for plant types that are not explicitly mapped in the switch
        // above (e.g. custom/dynamic plants defined in the backend structure
        // template, such as "addolcitore..." water softeners). Every document
        // archive bucket is an array whose entries carry the structureObjectId of
        // the structure item they belong to, so when no specific case resolved the
        // documents we can look them up generically by scanning every array bucket
        // for the entry matching this structure item id.
        var noSpecificMatch = !docs || Object.keys(docs).length === 0;
        if (noSpecificMatch && this.documentArchive) {
            var archiveKeys = Object.keys(this.documentArchive);
            try {
                for (var archiveKeys_1 = tslib_1.__values(archiveKeys), archiveKeys_1_1 = archiveKeys_1.next(); !archiveKeys_1_1.done; archiveKeys_1_1 = archiveKeys_1.next()) {
                    var archiveKey = archiveKeys_1_1.value;
                    var bucket = this.documentArchive[archiveKey];
                    if (Array.isArray(bucket)) {
                        var match = bucket.find(function (el) { return el && el.structureObjectId === itemId; });
                        if (match) {
                            docs = match;
                            break;
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (archiveKeys_1_1 && !archiveKeys_1_1.done && (_a = archiveKeys_1.return)) _a.call(archiveKeys_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        if (docs) {
            var keys = Object.keys(docs);
            if (keys.includes("documents")) {
                var obj_1 = docs["documents"];
                var _loop_2 = function (key) {
                    if (Array.isArray(obj_1[key]) && obj_1[key].length === 0) {
                        delete obj_1[key];
                    }
                    else if (Array.isArray(obj_1[key]) && obj_1[key].length) {
                        // tradurre ID22 ?
                        // cancellare doc scaduti || el.expired
                        // cancellare doc eliminati
                        // cancellare doc che non hanno data
                        obj_1[key].forEach(function (el) {
                            if (el.deleted || !el.data) {
                                delete obj_1[key];
                            }
                        });
                    }
                };
                for (var key in obj_1) {
                    _loop_2(key);
                }
            }
        }
        return docs;
    };
    /**
     * Open remake plant dialog
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onRemakeDialog = function () {
        var _this = this;
        // With the 3.0.0 archive switched on, the documents come from it (MAP-A1)
        if (isArchiveV3Live()) {
            this.onArchiveV3RemakeDialog();
            return;
        }
        var message = "properties.structures.textConfimFormRemake";
        var docs = this.getDocsFromArchive(this.activeItem.key, this.formActiveSubitemId);
        var dialogRef = this.dialog.open(PropertyDetailMappingRemakeDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant(message),
                docs: docs,
                propertyId: this.propertyId,
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
                subscriptionType: this.subscriptionType,
            },
            width: "800px"
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (res) {
                _this.subscriptions.push(_this.condoStructuresService
                    .deleteSection(_this.activeItem.section, _this.property.structure, _this.formActiveSubitemId)
                    .subscribe(function (resDel) {
                    if (resDel.status) {
                        _this.toastrService.success(resDel.message);
                        // @todo reload struttura
                        if (typeof docs !== "undefined") {
                            _this.condoStructuresService.setRemakeStrucutureDocs(_this.formActiveSection, docs._id, res);
                        }
                        _this.activateSection(_this.formActiveSection);
                    }
                    else {
                        _this.toastrService.error(resDel.message);
                    }
                }));
            }
        });
    };
    /**
     * «Elimina impianto» / «Elimina la scheda» with the 3.0.0 archive switched on (MAP-A1): the
     * confirmation lists the documents of the element from the new archive; the deletion is the one of
     * @see onDeleteDialog.
     *
     * @since 3.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onArchiveV3DeleteDialog = function () {
        var _this = this;
        // The element of the dialog: read now, not when the dialog answers
        var rawSection = this.activeItem.section;
        var elementId = this.formActiveSubitemId;
        var dialogRef = this.dialog.open(MappingArchiveDocsDialogComponent, {
            data: this.archiveV3DocsDialogData("delete", elementId),
            width: "800px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.condoStructuresService
                .deleteSection(rawSection, _this.property.structure, elementId)
                .subscribe(function (resDel) {
                if (resDel.status) {
                    _this.toastrService.success(resDel.message);
                    _this.router.navigate([_this.lang, "app", "properties", _this.property._id, "mapping"], { replaceUrl: true });
                }
                else {
                    _this.toastrService.error(resDel.message);
                }
            }, function (err) { return _this.helperService.handleError(err); }));
        });
    };
    /**
     * «Rifare impianto» with the 3.0.0 archive switched on (MAP-A1): the dialog lists the documents of
     * the plant from the new archive and hands back the ticked rows. After the deletion of
     * @see onRemakeDialog the selection is kept for the new plant, and the POST that creates it
     * (@see onFormSubmit) sends it as `remakePlantDocs`: `sourceStructureId` and
     * `documentArchiveDocIds`. The rows are read BEFORE the deletion, which withdraws them.
     *
     * @since 3.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onArchiveV3RemakeDialog = function () {
        var _this = this;
        // The plant being remade: read now, the active form changes once it is deleted
        var section = this.formActiveSection;
        var rawSection = this.activeItem.section;
        var sourceStructureId = this.formActiveSubitemId;
        var dialogRef = this.dialog.open(MappingArchiveDocsDialogComponent, {
            data: this.archiveV3DocsDialogData("remake", sourceStructureId),
            width: "800px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.condoStructuresService
                .deleteSection(rawSection, _this.property.structure, sourceStructureId)
                .subscribe(function (resDel) {
                if (resDel.status) {
                    _this.toastrService.success(resDel.message);
                    _this.condoStructuresService.setRemakePlantSelection(section, remakePlantSelection(sourceStructureId, res.documentArchiveDocIds));
                    _this.activateSection(section);
                }
                else {
                    _this.toastrService.error(resDel.message);
                }
            }, function (err) { return _this.helperService.handleError(err); }));
        });
    };
    /**
     * What the dialog of the 3.0.0 archive needs to list the documents of one element (MAP-A1).
     *
     * @since 3.0.0
     */
    PropertyDetailMappingTabComponent.prototype.archiveV3DocsDialogData = function (mode, elementId) {
        return {
            mode: mode,
            documentArchiveId: this.property ? this.property.documentArchive : "",
            structureObjectId: elementId,
            sectionPlant: this.sectionPlant,
        };
    };
    // /**
    //  * Open note dialog
    //  *
    //  * @since 1.0.0
    //  */
    // onNoteDialog(): void {
    //   const dialogRef = this.dialog.open(
    //     PropertyDetailMappingNoteDialogComponent,
    //     {
    //       data: {
    //         modalTitle: this.translateService.instant(
    //           "properties.structures.notes"
    //         ),
    //         existingNotes: this.existingNotes,
    //         condoStructureId: this.condoStructure._id,
    //         structureId: this.model._id,
    //         structureName: this.model.nome,
    //       },
    //       width: "500px"
    //     }
    //   );
    // }
    /**
     * Export properties in a file with given format
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onExport = function (target, propertyId) {
        var _this = this;
        // With the switch live, the two Excels of the property come from the new archive (NEW-M7)
        var archiveV3Target = isArchiveV3Live() ? documentArchiveExportTargetOf(target) : null;
        if (archiveV3Target !== null) {
            this.exportFromArchiveV3(archiveV3Target);
            return;
        }
        // If target is not provided, than just export all properties
        if (!target) {
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_1 = this.translateService.instant("properties.list.exportFileName") + " " + date;
            this.subscriptions.push(this.propertiesService.getExport().subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel"
                });
                FileSaver.saveAs(blob, fileName_1 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
        else if (target && typeof propertyId !== "undefined") {
            // Handle export for missing/inserted documents
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_2 = this.translateService.instant("properties.list." + target) + " " + date;
            this.subscriptions.push(this.propertiesService.getDocExport(target, propertyId).subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel"
                });
                FileSaver.saveAs(blob, fileName_2 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * «Esporta inseriti» and «Esporta mancanti» with the switch live: the Excel of the new archive, as
     * the «Esporta» menu of its dossier gives it. One download at a time; the entry is checked again
     * here and not only in the template, as the dossier does: a tab left open across a role change must
     * not ask for an Excel the new role is not shown.
     *
     * @since 3.0.0
     *
     * @param target Which Excel
     */
    PropertyDetailMappingTabComponent.prototype.exportFromArchiveV3 = function (target) {
        var _this = this;
        if (this.exportingTarget !== null || !this.propertyId || !this.downloadMenu[target]) {
            return;
        }
        this.exportingTarget = target;
        if (this.exportSubscription) {
            this.exportSubscription.unsubscribe();
        }
        this.exportSubscription = this.documentArchiveExportDownloadService
            .download(target, this.propertyId)
            .pipe(finalize(function () {
            _this.exportingTarget = null;
        }))
            .subscribe();
    };
    /**
     * Prevent redirect to archive if structure is open
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onGoToDocumentArchive = function () {
        if (!this.mappaturaOpen) {
            return;
        }
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('dialogs.confirm.mappaturaOpen.title'),
                message: this.translateService.instant('dialogs.confirm.mappaturaOpen.message'),
                btnCancelText: this.translateService.instant('common.cta.close'),
                messageOnly: true,
            },
            width: '500px',
            disableClose: false,
        });
        // // Subscribe to dialog result (only for 1 emit thanks to "take()")
        // dialogRef.beforeClosed()
        //   .pipe(
        //     take(1)
        //   )
        //   .subscribe(
        //     res2 => {
        //       if (res2) {
        //         // User hit confirm button. We can redirect him
        //         this.router.navigate([this.lang, 'app', 'properties', this.propertyId, 'documents']);
        //       }
        //     }
        //   );
    };
    /**
     * Handle click to show document notes
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onViewDocumentNotes = function () {
        var note = [];
        if (this.condoStructure) {
            var _loop_3 = function (key) {
                var e_3, _a, e_4, _b;
                if (Array.isArray(this_1.condoStructure[key]) &&
                    this_1.condoStructure[key].length) {
                    var structureTranslated_1 = '';
                    var find = false;
                    var structureTemplate = JSON.parse(JSON.stringify(this_1.condoStructureTemplate));
                    if (structureTemplate && Array.isArray(structureTemplate)) {
                        try {
                            for (var structureTemplate_1 = (e_3 = void 0, tslib_1.__values(structureTemplate)), structureTemplate_1_1 = structureTemplate_1.next(); !structureTemplate_1_1.done; structureTemplate_1_1 = structureTemplate_1.next()) {
                                var level1 = structureTemplate_1_1.value;
                                if (level1.content && Array.isArray(level1.content)) {
                                    try {
                                        for (var _c = (e_4 = void 0, tslib_1.__values(level1.content)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                            var level2 = _d.value;
                                            // if (level2.title === `properties.structures.${key}`) {
                                            if (level2.key === key) {
                                                structureTranslated_1 = level2.translation[this_1.lang];
                                                find = true;
                                                break;
                                            }
                                        }
                                    }
                                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                    finally {
                                        try {
                                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                        }
                                        finally { if (e_4) throw e_4.error; }
                                    }
                                }
                                if (find) {
                                    break;
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (structureTemplate_1_1 && !structureTemplate_1_1.done && (_a = structureTemplate_1.return)) _a.call(structureTemplate_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                    }
                    this_1.condoStructure[key].forEach(function (el, index) {
                        if (el.active && el.note && Array.isArray(el.note) && el.note.length) {
                            el.note.forEach(function (subEl, indexNote) {
                                note.push({
                                    createdAt: subEl.createdAt,
                                    createdBy: subEl.createdBy.firstName + " " + subEl.createdBy.lastName,
                                    text: subEl.text,
                                    name: el.nome ? el.nome : "",
                                    // structure: this.translateService.instant(
                                    //   "properties.structures." + key
                                    // ),
                                    structure: structureTranslated_1,
                                    structureName: key,
                                    structurePosition: index,
                                    structureId: el._id,
                                    notePosition: indexNote,
                                    noteId: subEl._id,
                                });
                            });
                        }
                    });
                }
            };
            var this_1 = this;
            for (var key in this.condoStructure) {
                _loop_3(key);
            }
        }
        var noteDialogRef = this.dialog.open(PropertyDetailDocumentNoteDialogComponent, {
            data: {
                modalTitle: this.translateService.instant("properties.documentsPage.noteList"),
                condoStructureId: this.condoStructure._id,
                notes: note,
            },
            minWidth: "50%",
        });
        // noteDialogRef
        //   .beforeClosed()
        //   .pipe(take(1))
        //   .subscribe((res) => {
        //     if (res && res.reload) {
        //       this.getStructureData();
        //     }
        //   });
    };
    /**
     * Word contracts export
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onExportContracts = function () {
        // With the switch live, the contracts come from the new archive, in their own dialog (FE-M8)
        if (isArchiveV3Live()) {
            if (this.propertyId && this.downloadMenu.contracts) {
                openDocumentArchiveExportContractsDialog(this.dialog, this.propertyId);
            }
            return;
        }
        var dialogRef = this.dialog.open(ExportContractsDialogComponent, {
            minWidth: "50%",
            maxHeight: "98vh",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * RAS docs export in PDF format
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onExportRAS = function () {
        // With the switch live, the RAS comes from the new archive, in its own dialog (FE-M8)
        if (isArchiveV3Live()) {
            if (this.propertyId && this.downloadMenu.ras) {
                openDocumentArchiveExportRasDialog(this.dialog, this.propertyId);
            }
            return;
        }
        var dialogRef = this.dialog.open(ExportRasDocsDialogComponent, {
            width: "700px",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * Handle click open QRcode dialogbox
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onPrintQRcode = function () {
        this.dialog.open(PrintQrcodeDialogComponent, {
            data: {
                title: this.translateService.instant("properties.detail.mappingTab.qrcodeDialog.title"),
                subtitle: this.translateService.instant("properties.detail.mappingTab.qrcodeDialog.subtitle"),
                propertyName: this.property.name,
                qrCode: this.mappingQrcodeData,
                name: this.companyData.name,
                city: this.companyData.legalAddress.city,
                address: this.companyData.legalAddress.route + " " + this.companyData.legalAddress.streetNumber
            },
            width: "700px",
        });
    };
    /**
     * Handle Qrcode send by email
     */
    PropertyDetailMappingTabComponent.prototype.onSendQrcodeByEmail = function () {
        var _this = this;
        var qrImage = document
            .getElementById("mappingQrcodeDataImage")
            .lastElementChild.lastElementChild.getAttribute("src");
        // Open dialog
        var newMessageDialogRef = this.dialog.open(AddCommunicationDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                body: this.translateService.instant("properties.detail.mappingTab.linkViewMapping", { link: this.mappingQrcodeData }),
                qrImage: qrImage,
                phonebook: this.companyData.phonebook,
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        newMessageDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.toastrService.success(_this.translateService.instant("communications.add.sendedSuccessfully"));
        });
    };
    /**
     * Handle edit
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onEdit = function (text, noteId) {
        var _this = this;
        var editDialogRef = this.dialog.open(PropertyEditNoteDialogComponent, {
            minWidth: "40%",
            maxHeight: "98vh",
            data: {
                title: this.translateService.instant("properties.structures.notes"),
                condoStructureId: this.condoStructure._id,
                text: text,
                structureName: this.model.nome ? this.model.nome : "Anagrafica",
                structureId: this.model._id,
                noteId: noteId,
            },
            disableClose: true,
        });
        editDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res || !res.status) {
                return;
            }
            var index = _this.existingNotes.findIndex(function (el) {
                return (el._id.toString() === noteId.toString());
            });
            if (index > -1) {
                _this.existingNotes[index].text = res.text;
            }
            return;
        });
    };
    /**
     * Handle delete
     *
     * @since 1.0.0
     */
    PropertyDetailMappingTabComponent.prototype.onDelete = function (noteId) {
        var _this = this;
        var confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
            minWidth: "30%",
            maxHeight: "98vh",
            data: {
                title: this.translateService.instant("common.warnings.warning"),
                message: this.translateService.instant("common.warnings.noteDelete"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        confirmDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.condoStructuresService
                .deleteNote(_this.condoStructure._id, _this.model.nome, _this.model._id, noteId)
                .pipe(take(1))
                .subscribe(function (res) {
                if (res.status) {
                    _this.toastrService.success(res.message);
                    var index = _this.existingNotes.findIndex(function (el) {
                        return (el._id.toString() === noteId.toString());
                    });
                    if (index > -1) {
                        _this.existingNotes.splice(index, 1);
                    }
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
            }));
            return;
        });
    };
    /**
     * Open a modal window to display the mapping of all open elements
     */
    PropertyDetailMappingTabComponent.prototype.onViewMapping = function () {
        this.dialog.open(PropertyDetailMappingViewDialogComponent, {
            width: '800px',
            data: {
                structureId: this.condoStructure._id,
            },
            disableClose: true,
        });
    };
    return PropertyDetailMappingTabComponent;
}());
export { PropertyDetailMappingTabComponent };
